export default {
  scene: {
    background: 0xffbc8d,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 500
    }
  },
  camera: {
    x: 0,
    y: 7,
    z: 27
  },
  environment: {
    path: '/models/environments/waitingroom.glb',
    rotation: 0,
    position: {
      x: 0,
      y: -5,
      z: 0
    }
  }
}
